<template>
  <div class="handle-container">
    <Navigation />
    <div class="handle-inner">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="query.hall" :to="{ path: '/hall' }">办事大厅</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: `guide?employId=${query.employId}&hall=${query.hall}` }">办理指南</el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form label-width="120px">
        <el-form-item v-for="item in itemList" :key="item.fieldName" :label="item.type === 10 ? '' : item.fieldTitle"
          :style="{ width: widthList[item.proportion - 1], '--color': item.isRequired ? 'red' : 'transparent' }">
          <!-- 单行文本 -->
          <el-input v-model="item.value" :maxlength="item.limitation" show-word-limit :placeholder="item.fieldReminder"
            clearable v-if="item.type === 1"></el-input>
          <!-- 地址选择 -->
          <el-cascader v-model="item.value" :options="regionTree"
            :props="{ value: 'regionId', label: 'name', children: 'childrenList' }" :placeholder="item.fieldReminder"
            v-if="item.type === 2"></el-cascader>
          <!-- 下拉选择 / 字典-->
          <el-select v-model="item.value" v-if="[3, 8].includes(item.type)" :multiple="item.fieldType === 1">
            <el-option v-for="{ optionValue } in item.optionList" :key="optionValue" :label="optionValue"
              :value="optionValue"></el-option>
          </el-select>
          <!-- 时间选择:年-->
          <el-date-picker v-model="item.value" type="year" :placeholder="item.fieldReminder"
            v-if="item.type === 4 && item.fieldType === 0"></el-date-picker>
          <!-- 时间选择:年月-->
          <el-date-picker v-model="item.value" type="month" :placeholder="item.fieldReminder"
            v-if="item.type === 4 && item.fieldType === 1"></el-date-picker>
          <!-- 时间选择:年月日-->
          <el-date-picker v-model="item.value" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :placeholder="item.fieldReminder" v-if="item.type === 4 && item.fieldType === 2"></el-date-picker>
          <!-- 时间选择:年月日 时分-->
          <el-date-picker v-model="item.value" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
            :placeholder="item.fieldReminder" v-if="item.type === 4 && item.fieldType === 3"></el-date-picker>
          <!-- 时间选择:时分-->
          <el-time-picker v-model="item.value" format="HH:mm" value-format="HH:mm" :placeholder="item.fieldReminder"
            v-if="item.type === 4 && item.fieldType === 4"></el-time-picker>
          <!-- 文本域 -->
          <el-input type="textarea" v-model="item.value" :maxlength="item.limitation" show-word-limit :rows="1"
            :placeholder="item.fieldReminder" v-if="item.type === 5"></el-input>
          <!-- 单选框-->
          <el-radio-group v-model="item.value" v-if="item.type === 6 && item.fieldType === 0">
            <el-radio v-for="{ optionValue } in item.optionList" :key="optionValue" :label="optionValue"></el-radio>
          </el-radio-group>
          <!-- 多选框 -->
          <el-checkbox-group v-model="item.value" v-if="item.type === 6 && item.fieldType === 1">
            <el-checkbox v-for="{ optionValue } in item.optionList" :key="optionValue"
              :label="optionValue"></el-checkbox>
          </el-checkbox-group>
          <!-- 附件 -->
          <el-upload :action="baseURL + '/base/upload'" :headers="uploadParams" :file-list="item.value"
            :before-upload="(file) => { beforeUpload(file, item) }"
            :on-success="(res, file, fileList) => { onSuccess(res, file, fileList, item) }"
            :on-remove="(_, fileList) => { removeFile(fileList, item) }" :limit="item.uploadNumber"
            :list-type="item.type === 9 ? 'picture' : ''" v-if="[7, 9].includes(item.type)">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="placeholder">{{ item.fieldReminder }}</div>
          </el-upload>
          <!-- 分割线 -->
          <el-divider :content-position="['left', 'center', 'right'][item.fieldType]" v-if="item.type === 10">{{
            item.fieldTitle }}</el-divider>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
    <Footer />
  </div>
</template>

<script>
import * as api from './api'
const { baseURL } = projectConfig
export default {
  name: 'Handle',
  components: {
    Navigation: () => import('../../components/Navigation'),
    Footer: () => import('../../components/Footer')
  },
  data() {
    return {
      query: {},
      itemList: [],
      widthList: ['25%', '50%', '75%', '100%'],
      baseURL,
      uploadParams: { token: localStorage.getItem('sys_token') },
      regionTree: []
    }
  },
  async created() {
    this.query = this.$route.query
    const { data: { formInfo: { fieldList } } } = await api.getFormItem(this.query.formId)
    this.itemList = fieldList.map(item => {
      return {
        ...item,
        format: item.type === 9 ? JSON.parse(item.format) : item.format,
        value: ([3, 6, 8].includes(item.type) && item.fieldType) || [7, 9].includes(item.type) ? [] : ''
      }
    })
    // 省市区
    const { data: { regionList } } = await api.getRegionTree()
    this.regionTree = regionList
  },
  methods: {
    submit() {
      // 表单项必填检验
      const requiredItem = this.itemList.filter(item => item.isRequired)
      if (requiredItem.length && requiredItem.find(item => item.value === '' || !item.value.length)) return this.$message.warning('请完善必填项')
      api.appleService({
        employId: this.query.employId,
        deployId: this.query.deployId,
        formData: {
          formId: this.query.formId,
          detailList: this.itemList.map(item => {
            return {
              fieldId: item.fieldId,
              fieldName: item.fieldName,
              fieldValue: Array.isArray(item.value) ? [7, 9].includes(item.type) ? item.value.map(i => i.name).join() : item.value.join() : item.value
            }
          })
        }
      })
      this.$message.success('提交成功')
      this.$router.push(`/guide?employId=${this.query.employId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.handle-container {
  .handle-inner {
    min-height: 100vh;
    width: var(--inner-width);
    margin: auto;
    padding: 50px 0;
    display: flex;
    flex-direction: column;

    ::v-deep.el-form {
      margin-top: 30px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      &-item {
        display: flex;
        margin: 0;
        width: 100%;
        border: 1px dashed transparent;
        padding: 10px;
        position: relative;
        display: flex;
        align-items: center;

        &__label {
          line-height: 24px;

          &::before {
            content: '*';
            color: var(--color);
            margin-right: 5px;
          }
        }

        &__content {
          width: 0;
          flex: 1;
          margin-left: 0 !important;

          .el-select,
          .el-cascader,
          .el-input {
            width: 100%;
          }

          .el-radio-group {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 15px 20px;

            .el-radio {
              margin: 0;
            }
          }

          .el-checkbox-group {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 0 20px;
          }

          .placeholder {
            font-size: 12px;
            line-height: 20px;
          }
        }
      }
    }

    .el-button {
      place-self: flex-end;
      margin: 10px;
    }
  }
}
</style>